export const FREDERICK_ID = 1;
export const MT_AIRY = 2;
export const LYNCH = 6;
export const MARION_ID = 8;
export const GREENWOOD = 9;
export const GOOGLE_API_KEY = "AIzaSyDg8QgP1N5JQHdB7-fIriQN3qx_E8BBG7g"

export const roles = {
  ADMIN: 1,
  PLANT_MANAGER: 2,
  SALESPERSON: 3,
  APPLICATOR: 4,
  SALES_MANAGEMENT: 5,
  DISPATCHER: 6,
}



// WEBPACK FOOTER //
// ./src/app/constants.js